import React from 'react';

import { CardElement } from '@stripe/react-stripe-js';

const cardNumberElementOptions = {
  style: {
    base: {
      fontSize: '13px',
      lineHeight: '18px',
      fontWeight: '600',
      color: '#545b7d',
    },
  },
};

const CardSection = () => {
  return (
    <div
      style={{
        borderBottom: '0.25px solid #545b7d',
        paddingBottom: '0.3rem',
        paddingTop: '1rem',
      }}
    >
      <CardElement options={cardNumberElementOptions} />
    </div>
  );
};

export default CardSection;
